import * as RA from 'ramda-adjunct';

export const isNilEmptyOrNaN = (valueToCheck: any): boolean =>
  RA.isNilOrEmpty(valueToCheck) || RA.isNaN(valueToCheck);

export const isNotNilEmptyOrNaN = (valueToCheck: any): boolean =>
  RA.isNotNilOrEmpty(valueToCheck) && RA.isNotNaN(valueToCheck);


